<template>
  <EditorContent
    class="editor-content px-4 py-4"
    :class="{ 'min-h-60': editor?.isEditable }"
    :editor="editor"
  />
</template>
<script setup lang="ts">
import './styles/main.css';
import { Editor, EditorContent } from '@tiptap/vue-3';

defineProps({
  editor: {
    type: Editor,
    default: null,
  },
});
</script>
